<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="descrição" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<textarea type="text"
						name="descrição"
						id="descrição"
						v-validate="'required'"
						rows="10"
						:class="{'is-invalid' : errors.has('descrição')}"
						v-model="form.descricao"
						class="form-control form-control-sm"></textarea>
				<span  class="invalid-feedback" v-show="errors.has('descrição')">{{ errors.first('descrição') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="revisaoManual" class="col-sm-2 col-form-label col-form-label-sm">*Revisão manual:</label>
			<div class="col-sm-10">
				<input type="text"
						name="revisaoManual"
						id="revisaoManual"
						v-validate="'required|max:10'"
						rows="10"
						:class="{'is-invalid' : errors.has('revisaoManual')}"
						v-model="form.revisaoManual"
						class="form-control form-control-sm"/>
				<span  class="invalid-feedback" v-show="errors.has('revisaoManual')">{{ errors.first('revisaoManual') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Mandatoria?</label>
			<div class="col-sm-10">
					<toggle-button
								v-model="form.mandatoria"
								:width="80"
								:height="30"
								:sync="true"
								:value="form.mandatoria"
								:labels="{checked: 'SIM', unchecked: 'NÃO'}"
								:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>
		</div>

		<div class="form-group row" v-if="form.id != 0">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Concluír?</label>
			<div class="col-sm-10">
					<toggle-button
								v-model="form.concluir"
								:width="80"
								:height="30"
								:sync="true"
								:value="form.concluir"
								:labels="{checked: 'SIM', unchecked: 'NÃO'}"
								:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>
		</div>

		<hr/>

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import axios from '../../../../routers/axios';
export default {
	data() {
		return {
			editar: false,
			form: {
				id: 0,
				descricao: "",
				revisaoManual: "",
				mandatoria: true,
				status: null,
				concluir: false
			}
		};
	},

	mounted() {},

	methods: {

		carregaDados(categoria, atualizacao) {
			if (atualizacao) {
				this.editar = true;
				this.form = atualizacao;
			}
			this.form.idConfigInspecao = categoria.id;
		},

		validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.salva();
				}
			});
		},

		salva() {
			const data = {
				...this.form,
				status: this.form.concluir ? "C" : this.form.status,
				enviaManutencao: this.form.concluir
			};

			this.$notify.loadIn('Salvando');

			if (this.editar) {
				axios
					.put(`${this._getUrl("api/atualizacaomanutencao")}/${this.form.id}`, data)
					.then(response => {
						this.$emit("item-salvo", response.data);
					});
			} else {
				axios
					.post(this._getUrl("api/atualizacaomanutencao"), data)
					.then(response => {
						this.editar = true;
						this.$emit("item-salvo", response.data);
					});
			}
		}
	}
};
</script>

<style>
.ir {
	position: absolute;
	right: 20px;
	top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/atualizacao.vue